class SplashScreen{
    constructor( config ){
        this.main = document.getElementById('splash-screen');
        this.setConfig(config);
    }

    setConfig( config = { showDescription: true, description: null} ){
        if(config){
            if(config.showDescription){
                this.main.querySelector('.description').classList.remove('d-none');
            }else{
                this.main.querySelector('.description').classList.add('d-none');
            }

            if(config.description){
                this.main.querySelector('.description').innerHTML = config.description;
            }
        }
    }

    show(){
        this.main.classList.add('splash-screen--show');
    }
    
    hide(){
        this.main.classList.remove('splash-screen--show');
    }
}

export default SplashScreen;